import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

/**
 * MotionSection — wraps children in a quiet entrance: 6px Y, fade in,
 * 0.45s ease-out. Honours `prefers-reduced-motion` (snaps to final).
 *
 * Use sparingly — opening band and section transitions, not every card.
 * Stagger by passing increasing `delay` to siblings.
 */
export function MotionSection({
  children,
  delay = 0,
  as = 'div',
}: {
  children: ReactNode;
  delay?: number;
  as?: 'div' | 'section';
}) {
  const reduce = useReducedMotion();
  const Component = as === 'section' ? motion.section : motion.div;

  return (
    <Component
      initial={reduce ? { opacity: 1, y: 0 } : { opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: 'easeOut', delay: reduce ? 0 : delay }}
    >
      {children}
    </Component>
  );
}
